import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import {
  deepOrange,
  deepPurple,
  amber,
  brown,
  blueGrey,
  lime,
  blue,
} from "@mui/material/colors";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "@mui/material";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CoursePlan() {
  const [expanded, setExpanded] = React.useState("panel1");

  React.useEffect(() => {
    AOS.init();
  }, []);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <div data-aos="flip-right">
      <Typography
        align="center"
        className="py-3"
        fontWeight={600}
        variant={matches ? "h5" : "h4"}
        gutterBottom
      >
        <span className="text-warning">Course</span> Plan
      </Typography>
      {/*--- week-1 ---*/}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar
            sx={{
              bgcolor: deepOrange[500],
              width: 27,
              height: 27,
            }}
          >
            1
          </Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: deepOrange[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      1
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      Introduction to PRTP and introduction to Research
                    </span>
                    <span className="d-block">
                      Basic terminologies of Research
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DMAH</span>
                    <span className="d-block">DMAH</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: deepOrange[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      2
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>Research Design</span>
                    <span className="d-block">
                      Sample and Questionnaire Designs and Data Collection
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DMAH</span>
                    <span className="d-block">DMAH</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      {/*--- week-2 ---*/}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: deepPurple[500], width: 27, height: 27 }}>
            2
          </Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: deepPurple[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      3
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>Variable Generation and Scaling Techniques</span>
                    <span className="d-block">
                      Descriptive Measures of Data Analysis
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>MAH</span>
                    <span className="d-block">MAH</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: deepPurple[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      4
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      Statistical Inference: Hypothesis Testing for Parametric
                      Tests (Part I)
                    </span>
                    <span className="d-block">
                      Statistical Inference: Hypothesis Testing for Parametric
                      Tests (Part II)
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>SMNA</span>
                    <span className="d-block">SMNA</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      {/*--- week-3 ---*/}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: amber[500], width: 27, height: 27 }}>3</Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: amber[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      5
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      Analysis of Variance (ANOVA) and Statistical Inference:
                      Hypothesis Testing for Non-Parametric Tests (Part I)
                    </span>
                    <span className="d-block">
                      Statistical Inference: Hypothesis Testing for
                      Non-Parametric Tests (Part II)
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>SMNA</span>
                    <span className="d-block">SMNA</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: amber[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      6
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>Analysis of Simple Regression Model</span>
                    <span className="d-block">
                      Analysis of Multiple Regression Model
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>MAH</span>
                    <span className="d-block">MAH</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      {/*--- week-4 ---*/}
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel4d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: brown[500], width: 27, height: 27 }}>4</Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: brown[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      7
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>Analysis of Time Series Data</span>
                    <span className="d-block">Analysis of Panel Data</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DRSP</span>
                    <span className="d-block">DRSP</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: brown[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      8
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      SPSS: Data Cleaning, Detecting Outlier, and Descriptive
                      Statistics- Tabular and Graphical (Quantitative and
                      Qualitative) Analysis of Survey Data
                    </span>
                    <span className="d-block">
                      SPSS: Correlation, Regression, and ANOVA Analyses and
                      Hypothesis Testing
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>SMNA</span>
                    <span className="d-block">SMNA</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      {/*--- week-5 ---*/}
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel5d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: lime[500], width: 27, height: 27 }}>5</Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: lime[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      9
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      STATA: Data Cleaning, Detecting Outlier, and Descriptive
                      Statistics- Tabular and Graphical (Quantitative and
                      Qualitative) Analysis of Survey Data
                    </span>
                    <span className="d-block">
                      STATA: Correlation, Regression, and ANOVA Analyses and
                      Hypothesis Testing
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>SMNA</span>
                    <span className="d-block">SMNA</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: lime[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      10
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>Eviews for Analysis (Part I)</span>
                    <span className="d-block">
                      Eviews for Analysis (Part II)
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DMMH</span>
                    <span className="d-block">DMMH</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>

      {/*--- week-6 ---*/}
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel6d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: blueGrey[500], width: 27, height: 27 }}>
            6
          </Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: blueGrey[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      11
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>FGD and KII in field research</span>
                    <span className="d-block">
                      Research Proposal, Full Research Paper, and Research
                      Presentation Writings with Plagiarism Solution (Part I)
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DRSP</span>
                    <span className="d-block">DMJA</span>
                  </TableCell>
                </TableRow>

                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: blueGrey[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      12
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">
                    <span>S1</span>
                    <span className="d-block">S2</span>
                  </TableCell>
                  <TableCell align="left">
                    <span>
                      Research Proposal, Full Research Paper, and Research
                      Presentation Writings with Plagiarism Solution (Part II)
                    </span>
                    <span className="d-block">
                      Publication or Submission of a Research Paper
                    </span>
                  </TableCell>
                  <TableCell align="left">
                    <span>DMJA</span>
                    <span className="d-block">DMMH</span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>

      {/*--- week-7 ---*/}
      <Accordion
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel7d-header">
          <Typography sx={{ mx: 1 }}>Week</Typography>
          <Avatar sx={{ bgcolor: blue[500], width: 27, height: 27 }}>7</Avatar>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: blueGrey[100] }}>
                  <TableCell>Class</TableCell>
                  <TableCell align="left">Session</TableCell>
                  <TableCell align="left">Topic</TableCell>
                  <TableCell align="left">Teacher</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Avatar
                      sx={{
                        bgcolor: blue[500],
                        width: 22,
                        height: 22,
                        fontSize: "14px",
                      }}
                    >
                      13
                    </Avatar>
                  </TableCell>
                  <TableCell align="left">S1</TableCell>
                  <TableCell align="left">
                    DID (Difference in differences) Model, Others model if any
                  </TableCell>
                  <TableCell align="left">MLR</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
